import { AuthConsumer } from "./authProvider";
import { LoadingIndicator } from "../components/common/VFX-UI";

const SignInCallback = () => (
  <AuthConsumer>
    {({ signinRedirectCallback }) => {
      signinRedirectCallback();
      return <LoadingIndicator />;
    }}
  </AuthConsumer>
);

export default SignInCallback;
